module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_au-2216ea112d6022edb6c230d688fd3815.png";